import { Box } from "@mui/material";
import { AreaItem } from "./area-item";
import { usePlannerContext } from "../../../services/context/planner-context";
import { CAR_PARKING_TYPE } from "../../../constants/global.constants";
import { useUserContext } from "../../../services/context/user-context";

export const AreaList = ({}) => {
  const { userData, viewOnly } = useUserContext();
  const { nodes, buildingsTypes } = usePlannerContext();

  const hasCarPark = !!nodes.find(
    (item) => item.data.type === CAR_PARKING_TYPE
  );
  const buildingsCount = nodes.filter(
    (item) => item.data.type !== CAR_PARKING_TYPE
  ).length;

  return (
    <Box
      className="area-list"
      sx={{
        width: "100%",
        height: "auto",
        padding: "6px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        overflow: "auto",
      }}
    >
      {buildingsTypes.map((area) => (
        <AreaItem
          key={area.id}
          area={area}
          disabled={
            viewOnly ||
            (!userData.isAdmin
              ? area.node_name === CAR_PARKING_TYPE
                ? hasCarPark
                : buildingsCount >= 10
              : false)
          }
        />
      ))}
    </Box>
  );
};
